import React, { Component } from 'react';
import { SkyLightStateless } from 'react-skylight';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Grid, Row, Col, Panel, Button, Breadcrumb, ButtonToolbar } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import forEach from 'lodash/forEach';

import ContentWrapper from '../../components/Layout/ContentWrapper';
import { UI_HEIGHT, BACKGROUND_COLOR, APP_COLORS } from '../Common/constants';
import {
  roundTo,
  getRoundingFunc,
  calculatePriceLevel,
  calculatePricePercentage,
  priceLevelFieldsMap,
  priceLevelPercentageFieldsMap,
} from '../Common/NumberUtil';
import Spinner from '../../components/Widgets/spinner';
import FilterByStart from '../Common/filterByStart';
import checkPermission from '../Common/permissions';
import { ROOT_URL, companyCodeTitle } from '../../actions/root_url';
import CashFormatter from '../Common/cashFormatter';
import ProdNumFormatter from '../Common/ProdNumFormatter';
import GenericSelection from '../Common/GenericSelection';

class PriceLevel extends Component {
  static contextTypes = {
    router: React.PropTypes.object,
  };

  constructor() {
    super();
    this.state = {
      tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton,

      rows: [],
      selectedRows: null,
      editedRows: [],
      filters: {},
      sortColumn: null,
      sortDirection: null,
      currentGroup: null,
      currentCategory: null,
      groupExpanded: false,
      isCalculationSelectionModalOpen: false,
      calculationTypeSelected: 'Cost Profit',
      isSavingCalculationType: false,
    };

    this.handleResize = this.handleResize.bind(this);
  }

  componentWillMount() {
    this.props.resetGroupAndCategory();
  }

  componentDidMount() {
    document.title = companyCodeTitle;
    window.addEventListener('resize', this.handleResize);
    this.props.fetchGroups();
    // this.props.fetchPriceLevels();
  }

  // Once priceLevels are ready, reset state.

  componentWillReceiveProps(nextProps) {
    if (nextProps.groups && nextProps.groups.length !== 0 && nextProps.groups !== this.props.groups) {
      const productGroup_id = nextProps.groups[0].ProductGroup_id;
      this.props.fetchPriceLevels('ProductGroup_id', productGroup_id);
      this.setState({ currentGroup: productGroup_id });
    }
    if (nextProps.priceLevels && nextProps.priceLevels !== this.props.priceLevels) {
      this.setState({
        rows: nextProps.priceLevels, editedRows: [],
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const productGroup_id = this.state.currentGroup;
    const productCategory_id = this.state.currentCategory;
    const groups = document.getElementsByName('group');
    let i = 0;
    for (; i < groups.length; i++) {
      if (groups[i].id != `g${productGroup_id}`) {
        groups[i].style.backgroundColor = null;
      } else {
        groups[i].style.backgroundColor = APP_COLORS['active-category-background-nav'];
      }
    }
    const categories = document.getElementsByName('category');
    // console.log('categories', categories);
    i = 0;
    if (categories) {
      for (; i < categories.length; i++) {
        if (categories[i].id !== `c${productCategory_id}`) {
          categories[i].style.backgroundColor = null;
        } else {
          categories[i].style.backgroundColor = APP_COLORS['active-category-background-nav'];
        }
      }
    }
  }

  componentWillUnmount() {
    this.props.setOriginPage('priceLevel');
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize(e) {
    this.setState({
      tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton
    });
  }

  updateRows(e) {
    e.preventDefault();
    this.props.editMultiPriceLevels(this.state.editedRows);
  }

  handleProductLineDoubleClick = (product) => {
    Promise.resolve(this.props.selectProduct(product))
      .then(() => {
        this.context.router.push(`/products/${product.Product_id}`);
      });
  }

  handleClickCategory(id) {
    this.props.fetchPriceLevels('ProductCategory1_id', id);
    this.setState({
      currentCategory: id,
    });
  }

  handleClickGroup(group) {
    const { groupExpanded } = this.state;
    if (group && this.state.currentGroup === group.ProductGroup_id) {
      this.setState({
        groupExpanded: !groupExpanded,
      });
      if (!groupExpanded) {
        this.setState({
          currentCategory: -1,
        });
        this.props.fetchPriceLevels('ProductGroup_id', group.ProductGroup_id);
        this.props.fetchGroupCategories(group.ProductGroup_id);
      }
    } else if (group) {
      this.setState({
        currentGroup: group.ProductGroup_id,
        groupExpanded: true,
        currentCategory: -1
      });
      this.props.fetchPriceLevels('ProductGroup_id', group.ProductGroup_id);
      this.props.fetchGroupCategories(group.ProductGroup_id);
    } else {
      this.setState({
        currentGroup: -1,
        currentCategory: -1,
      });
      this.props.fetchPriceLevels('All', -1);
    }
  }

  handleSelectionChange = (value, fieldName) => {
    this.setState({ [fieldName]: value });
  }

  handleSaveCalculationTypeClick = () => {
    const handleSuccess = () => {
      this.setState({ isSavingCalculationType: false }, () => {
        this.closeCalculationSelectionModal();
      });
    };

    const handleFailure = (error) => {
      this.setState({ isSavingCalculationType: false }, () => {
        alert(error);
      });
    };

    this.setState({ isSavingCalculationType: true }, () => {
      this.setState({ isSavingCalculationType: false });
      // this.saveCalculationType(type, handleSuccess, handleFailure);
    });
  }

  openCalculationSelectionModal = () => {
    this.setState({ isCalculationSelectionModalOpen: true });
  }

  closeCalculationSelectionModal = () => {
    this.setState({ isCalculationSelectionModalOpen: false });
  }

  // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.

  renderTable() {
    if (this.props.isLoading && !this.props.error) {
      return (
        <div>
          <Spinner />
        </div>
      );
    } else if (this.props.error) {
      return (
        <ContentWrapper>
          <div className="alert alert-danger" id="price-level-error">
            {JSON.stringify(this.props.error)}
          </div>
        </ContentWrapper>
      );
    }
    // Parameters of the react-data-grid

    const getRows = () => Data.Selectors.getRows(this.state);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    // Handle the sortable function

    const handleGridSort = (sortColumn, sortDirection) => {
      const state = Object.assign({}, this.state, { sortColumn, sortDirection });
      this.setState(state);
    };

    const handleFilterChange = (filter) => {
      const newFilters = Object.assign({}, this.state.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      this.setState({ filters: newFilters });
    };

    // Handle the editable function

    const handleRowUpdated = (e) => {
      // let rows = this.state.rows.slice(0);
      const rows = getRows();
      Object.assign(rows[e.rowIdx], e.updated);
      const {
        updated: updatedRow,
        cellKey: currentCellKey,
      } = e;
      const currentRow = rows[e.rowIdx];

      switch (currentCellKey) {
        case 'RefPrice':
          forEach(priceLevelFieldsMap, (pricePercentage, priceLevel) => {
            currentRow[priceLevel] = calculatePriceLevel(currentRow.PriceType)(currentRow[pricePercentage], updatedRow.RefPrice);
          });
          break;

        /* currentCellKey price levels */
        case 'PriceLv1':
        case 'PriceLv2':
        case 'PriceLv3':
        case 'PriceLv4':
        case 'PriceLv5':
          // set updated price level
          currentRow[currentCellKey] = +getRoundingFunc(currentRow.PriceType)(updatedRow[currentCellKey], 2);
          // set updated price level percentage
          currentRow[priceLevelFieldsMap[currentCellKey]] =
            calculatePricePercentage(currentRow[currentCellKey], currentRow.RefPrice);
          break;

        /* currentCellKey percentages */
        case 'P1Percentage':
        case 'P2Percentage':
        case 'P3Percentage':
        case 'P4Percentage':
        case 'P5Percentage':
          // set updated price level
          currentRow[currentCellKey] = +roundTo(updatedRow[currentCellKey], 2);
          // set updated price level percentage
          currentRow[priceLevelPercentageFieldsMap[currentCellKey]] =
            calculatePriceLevel(currentRow.PriceType)(
              currentRow[currentCellKey],
              currentRow.RefPrice,
            );
          break;
        default:
          break;
      }
      // merge updated row with current row and rerender by setting state
      const editedRows = this.state.editedRows.slice(0);
      // if the element is already edited, remove the old one.
      editedRows.forEach((element, index) => {
        if (element.Product_id === currentRow.Product_id) { editedRows.splice(index, 1); }
      }, this);
      // push the row into the editedRows array
      editedRows.push(currentRow);
      this.setState({
        rows,
        editedRows,
      });
    };

    // Handle the Dragable cell function

    const handleCellDrag = (e) => {
      const rows = this.state.rows.slice(0);
      const editedRows = this.state.editedRows.slice(0);
      for (let i = e.fromRow; i <= e.toRow; i++) {
        const rowToUpdate = rows[i];
        rowToUpdate[e.cellKey] = e.value;
        // if the element is already edited, remove the old one.
        editedRows.forEach((element, index) => {
          if (element.Product_id === rowToUpdate.Product_id) { editedRows.splice(index, 1); }
        }, this);
        // push the row into the editedRows array
        editedRows.push(rowToUpdate);
      }
      this.setState({
        rows,
        editedRows,
      });
    };

    const handleDragHandleDoubleClick = (e) => {
      const rows = this.state.rows.map(r => Object.assign({}, r));
      const editedRows = this.state.editedRows.slice(0);
      const column = columns[e.idx - 1];
      for (let i = e.rowIdx; i <= rows.length - 1; i++) {
        var rowToUpdate = rows[i];
        rowToUpdate[column.key] = e.rowData[column.key];
        // if the element is already edited, remove the old one.
        editedRows.forEach((element, index) => {
          if (element.Product_id === rowToUpdate.Product_id) { editedRows.splice(index, 1); }
        }, this);
        // push the row into the editedRows array
        editedRows.push(rowToUpdate);
      }
      this.setState({ rows });
    };

    // Custom Formatter component
    const IsEnabledFormatter = React.createClass({
      render() {
        if (this.props.value) return <span className="label label-success">Enabled</span>;
        return <span className="label label-danger">Disable</span>;
      },
    });

    // Handle the row select function

    const onRowSelect = (rows) => {
      this.setState({ selectedRows: rows });
    };

    // Column difinition

    const columns = [
      {
        key: 'ProductNum',
        name: <Translate value="prod_num" />,
        resizable: true,
        sortable: true,
        filterable: true,
        filterRenderer: FilterByStart,
        width: 70,
        formatter: <ProdNumFormatter onDoubleClick={this.handleProductLineDoubleClick} />,
        getRowMetaData: row => row,
      },
      {
        key: 'RefNum',
        name: <Translate value="ref_num" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        filterRenderer: FilterByStart,
      },
      {
        key: 'Name',
        name: <Translate value="name" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 180,
      },
      {
        key: 'Description',
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 120,
      },
      {
        key: 'ProductCost',
        name: <Translate value="prod_cost" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 60,
        formatter: CashFormatter,
      },
      {
        key: 'InStockPrice',
        name: <Translate value="avg_cost" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 60,
        formatter: CashFormatter,
      },
      {
        key: 'LowestSalePrice',
        name: <Translate value="lowest_sale_dollarsign" />,
        resizable: true,
        sortable: true,
        editable: true,
        filterable: true,
        width: 65,
        formatter: CashFormatter,
      },
      {
        key: 'RefPrice',
        name: <Translate value="ref_dollarsign" />,
        resizable: true,
        sortable: true,
        editable: true,
        filterable: true,
        width: 60,
        getRowMetaData: row => row,
        formatter: CashFormatter,
      },
      {
        key: 'Difference',
        name: <Translate value="difference" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 60,
        formatter: CashFormatter,
      },
      {
        key: 'P1Percentage',
        name: <Translate value="lv_1_%" />,
        resizable: true,
        sortable: true,
        editable: true,
        width: 60,
      },
      {
        key: 'PriceLv1',
        name: <Translate value="lv_1" />,
        resizable: true,
        sortable: true,
        editable: true,
        filterable: true,
        width: 60,
        formatter: CashFormatter,
      },
      {
        key: 'P2Percentage',
        name: <Translate value="lv_2_%" />,
        resizable: true,
        sortable: true,
        editable: true,
        filterable: true,
        width: 60,
      },
      {
        key: 'PriceLv2',
        name: <Translate value="lv_2" />,
        resizable: true,
        sortable: true,
        editable: true,
        filterable: true,
        width: 60,
        formatter: CashFormatter,
      },
      {
        key: 'P3Percentage',
        name: <Translate value="lv_3_%" />,
        resizable: true,
        sortable: true,
        editable: true,
        filterable: true,
        width: 60,
      },
      {
        key: 'PriceLv3',
        name: <Translate value="lv_3" />,
        resizable: true,
        sortable: true,
        editable: true,
        filterable: true,
        width: 60,
        formatter: CashFormatter,
      },
      {
        key: 'P4Percentage',
        name: <Translate value="lv_4_%" />,
        resizable: true,
        sortable: true,
        editable: true,
        filterable: true,
        width: 60,
      },
      {
        key: 'PriceLv4',
        name: <Translate value="lv_4" />,
        resizable: true,
        sortable: true,
        editable: true,
        filterable: true,
        width: 60,
        formatter: CashFormatter,
      },
      {
        key: 'P5Percentage',
        name: <Translate value="lv_5_%" />,
        resizable: true,
        sortable: true,
        editable: true,
        filterable: true,
        width: 60,
      },
      {
        key: 'PriceLv5',
        name: <Translate value="lv_5" />,
        resizable: true,
        sortable: true,
        editable: true,
        filterable: true,
        width: 60,
        formatter: CashFormatter,
      },
      {
        key: 'Profit',
        name: <Translate value="profit_pl" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 60,
      },
    ];

    return (
      <Row>
        <Col sm={12}>
          <div style={{ maxWidth: '99%' }} id="PriceLevel-dataGrid1">
            <ReactDataGrid
              rowKey="Product_id"
              rowRenderer={<RowRenderer />}
              enableCellSelect
              onGridSort={handleGridSort}
              toolbar={<Toolbar enableFilter />}
              onAddFilter={handleFilterChange}
              columns={columns}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              rowHeight={25}
              headerRowHeight={45}
              minHeight={600}
              onDragHandleDoubleClick={handleDragHandleDoubleClick}
              onCellsDragged={handleCellDrag}
              onRowUpdated={handleRowUpdated}
              onRowSelect={onRowSelect}
            />
          </div>
        </Col>
      </Row>
    );
  }

  renderCategories(group_id) {
    if (!this.props.groupCategories) return;
    const groupCategories = this.props.groupCategories;
    let description;
    if (localStorage.getItem('lang') == 'ch') {
      description = 'Description';
    } else if (localStorage.getItem('lang') == 'en') {
      description = 'Name';
    }
    if (this.state.currentGroup == group_id && this.state.groupExpanded) {
      return groupCategories.map(category => (
        <li className="clickListLi" style={{ color: APP_COLORS['sub-category-nav'], fontFamily: 'Arial' }} name="category" id={`c${category.ProductCategory_id}`} onClick={this.handleClickCategory.bind(this, category.ProductCategory_id)}>
          <label style={{ fontWeight: 'bold' }}>{category.CategoryNum}</label>{` ${category[description]}`}
        </li>
      ));
    }
  }

  renderGroups() {
    if (!this.props.groups) return;
    const groups = this.props.groups;
    return groups.map((group) => {
      let GroupNum = parseInt(group.GroupNum);
      if (GroupNum < 10) GroupNum = `0${GroupNum}`;
      let description;
      if (localStorage.getItem('lang') == 'ch') {
        description = 'Description';
      } else if (localStorage.getItem('lang') == 'en') {
        description = 'Name';
      }
      return (
        <Panel className="panelStyle" >
          <div style={{ color: APP_COLORS['category-nav'], fontFamily: 'Arial Black', cursor: 'pointer' }} name="group" id={`g${group.ProductGroup_id}`} onClick={this.handleClickGroup.bind(this, group, `g${group.ProductGroup_id}`)}>
            <label style={{ fontWeight: 'bold' }}>{GroupNum}</label> {` ${group[description]}`}
          </div>
          {this.renderCategories(group.ProductGroup_id)}
        </Panel>
      );
    });
  }

  renderCalculationSelectionModal = () => {
    const calculationTypeOptions = [
      { label: 'Cost Profit', value: 'Cost Profit' },
      { label: 'Sales Profit', value: 'Sales Profit' },
    ];
    return (
      <div className="price-level-calculation-type-modal">
        <GenericSelection
          setSelected={({ value }) => this.handleSelectionChange(value, 'calculationTypeSelected')}
          value={this.state.calculationTypeSelected}
          options={calculationTypeOptions}
        />
        <div className="price-level-calculation-display">
          <div className="price-level-equation">
            { 'Price level % =' }
            <div className="price-level-equation-right-side">
              { 'Price Level $ - Ref Cost' }
              <hr className="horizontal-division-divider" />
              {
                this.state.calculationTypeSelected === 'Cost Profit'
                  ? <span>Ref Cost $</span>
                  : <span>Price Level $</span>
              }
            </div>
          </div>
        </div>
        <Button
          bsStyle="success"
          className="calculation-type-save-button"
          onClick={() => this.handleSaveCalculationTypeClick()}
          disabled={this.state.isSavingCalculationType}
        >
          <em className="fa fa-save" /><Translate value="save" />
        </Button>
      </div>
    );
  }

  render() {
    const createDialogStyle = {
      width: '650px',
      marginLeft: '-15%',
    };
    const calculationSelectionModalTitle = (<Translate value="price_level_calculation_type" />);
    let exportUrl = '';
    if (this.state.currentGroup && this.state.currentGroup > -1 && this.state.currentCategory == -1) {
      exportUrl = `${ROOT_URL}v1/product/pricelevel/excel?ProductGroup_id=${this.state.currentGroup}&Bearer=${localStorage.getItem('token')}`;
    } else if (this.state.currentCategory && this.state.currentCategory > -1) {
      exportUrl = `${ROOT_URL}v1/product/pricelevel/excel?ProductCategory1_id=${this.state.currentCategory}&Bearer=${localStorage.getItem('token')}`;
    } else {
      exportUrl = `${ROOT_URL}v1/product/pricelevel/excel?&Bearer=${localStorage.getItem('token')}`;
    }
    return (
    //---------------
    // Begin HTML: Create New/Edit Sales Invoice
    //---------------
      <ContentWrapper>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="general_management" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value="price_level" />
          </Breadcrumb.Item>
        </Breadcrumb>
        <ButtonToolbar id="breadcrumbButtonGroup">
          <Button
            bsStyle="success"
            className="buttonStyle"
            onClick={(event) => { this.updateRows(event); }}
            disabled={!this.state.editedRows || !checkPermission('change_price_level')}
          ><em className="fa fa-save" /> <Translate value="save" />
          </Button>
        </ButtonToolbar>
        {/* <div className="content-heading"><Translate value="price_level"/></div> */}


        <Grid fluid="true" id="price-management-page">
          <Row>
            <Col sm={2}>
              <Panel id="category-nav" className="panelStyle" style={{ overflowY: 'scroll', width: '100%' }}>
                <Panel className="panelStyle" >
                  <div style={{ color: APP_COLORS['category-nav'], fontWeight: 'bold', cursor: 'pointer' }} name="group" id="g-1" onClick={this.handleClickGroup.bind(this, null, '-1')}>
                    <Translate value="all" />
                  </div>
                </Panel>
                {this.renderGroups()}
              </Panel>
            </Col>
            <Col sm={10}>
              <Panel id="products" className="position-relative" >
                <ButtonToolbar className="table-buttons">
                  <Button
                    bsStyle="success"
                    className="export-to-excel"
                    href={exportUrl}
                  >
                    <em className="fa fa-download" />
                    <Translate value="export" />
                  </Button>
                  {/* <Button
                    bsStyle="warning"
                    className=""
                    onClick={() => this.openCalculationSelectionModal()}
                  >
                    <em className="fa fa-pencil" />
                    <Translate value="edit_calculation_type" />
                  </Button> */}
                </ButtonToolbar>
                {this.renderTable() }
                <br />
                <Row>
                  <Col sm={2}>
                    { this.props.multiIsEditing && <div><Spinner /><Translate value="uploading" /></div> }
                    { this.props.multiEdited && <div className="alert alert-success"><Translate value="saved" /></div>}
                    { this.props.multiError && <div className="alert alert-danger marginTopStyle" >{this.props.multiError.detail}</div> }
                  </Col>
                </Row>
              </Panel>
            </Col>
          </Row>
          <SkyLightStateless
            dialogStyles={createDialogStyle}
            isVisible={this.state.isCalculationSelectionModalOpen}
            onCloseClicked={() => { this.closeCalculationSelectionModal(); }}
            title={calculationSelectionModalTitle}
          >
            { this.renderCalculationSelectionModal() }
          </SkyLightStateless>
        </Grid>
      </ContentWrapper>
    );
  }
}

export default PriceLevel;

class RowRenderer extends Component {
  getRowStyle() {
    return {
      color: this.getRowBackground(),
    };
  }

  getRowBackground() {
    return this.props.row.RefPrice < this.props.row.ProductCost ? BACKGROUND_COLOR.red : 'black';
  }

  render() {
    // here we are just changing the style
    // but we could replace this with anything we liked, cards, images, etc
    // usually though it will just be a matter of wrapping a div, and then calling back through to the grid
    return (
      <div style={this.getRowStyle()}>
        <ReactDataGrid.Row ref="row" {...this.props} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./master/jsx/components/Products/priceLevel.jsx